import {cookies} from "@intermesh/goui";
import {PortalConfig} from "../config.js";

export type HttpVerb = "GET" | "HEAD" | "POST" | "PUT" | "PATCH" | "DELETE" | "CONNECT" | "OPTIONS";

type UploadResponse = {
	id: string,
	size: number,
	type: string,
	name: string,
	file: File,
	subfolder: string | undefined
}

export class ServerApi {
	static headers: HeadersInit = {};

	static readonly baseUrl: string = PortalConfig.APIUrl;


	static get defaultRequestOptions(): RequestInit {
		let headers = ServerApi.headers;
		Object.assign(headers, {
			"Content-Type": "application/json",
			"Accept-Language": sessionStorage.getItem("language") || "nl"
		});
		if (cookies.get("accessToken")) {
			Object.assign(headers, {
				"Authorization": "Token " + cookies.get("accessToken")
			});
		} else if(sessionStorage.getItem("accessToken")) {
			Object.assign(headers, {
				"Authorization": "Token " + sessionStorage.getItem("accessToken")
			});
		}
		return {
			method: "GET" as HttpVerb,
			headers: headers,
			mode: "same-origin"
		}
	}

	static async call(route: string, body = {}, method?: HttpVerb): Promise<any> {
		let options = ServerApi.defaultRequestOptions;

		const url = ServerApi.url(route, undefined, true);

		options.method = method || "GET";
		if (options.method !== "GET") {
			options.body = JSON.stringify({data: body});
		}
		const response = await fetch(url, options);
		if(!response.ok) {
			throw await this.createErrorFromResponse(response);
		}
		return await response.json();
	}

	protected static async createErrorFromResponse(response: Response) {
		const text = await response.text();
		try {

			const data = JSON.parse(text);

			if(data.data && data.data.validationErrors) {
				return {type: "invalidProperties", validationErrors: data.data.validationErrors, data: data};
			} else {
				return {type: "serverFail",  data: data, status:  response.status, statusText: response.statusText};
			}
		}	catch(e) {
			//ignore
		}

		return new Error("Request error: " + response.status + " " + response.statusText + "\n\n" + text);
	}

	/**
	 * generate a URL with parameters
	 *
	 * @param route :string
	 * @param params :object
	 * @param includeBaseUrl :boolean
	 */
	static url(route: string, params?: object, includeBaseUrl = false): string {
		if (!route && !params) {
			return "";
		}

		let url = (includeBaseUrl ? ServerApi.baseUrl : "") + route;

		params = params || {};

		let amp = false;

		if (params) {
			for (let [key, value] of Object.entries(params)) {
				switch (typeof value) {
					case "string":
						break;
					case "boolean":

						value = value ? '1' : '0';
						break;

					default:
						value = JSON.stringify(value);
						break;
				}

				if (amp) {
					url += '&';
				} else {
					url += '?';
					amp = true;
				}

				url += key + "=" + encodeURIComponent(value);
			}
		}

		return url;

	}

	static thumbUrl(blobId: string, h: number, w: number, zoomCrop = false) {
		return ServerApi.url(ServerApi.baseUrl + "thumb/" + blobId, {w: w, h: h, zoomCrop: zoomCrop});
	}

	static downloadUrl(blobId: string) {
		return ServerApi.url(ServerApi.baseUrl + "download/"+blobId);
	}

	static scormUrl(blockId: number, languageId: number): string {
		return ServerApi.url(ServerApi.baseUrl + "elearning/content/" + blockId + "/" + languageId + "/", {});
	}

	static async upload(file: File): Promise<any> {
		const url = ServerApi.url("upload", {}, true);

		let options = ServerApi.defaultRequestOptions;
		options.method = "POST";
		options.mode = "same-origin";
		options.credentials = "include";

		const headers: HeadersInit = options.headers!;
		Object.assign(headers, {
			"X-File-Name": "UTF-8''" + encodeURIComponent(file.name),
			"Content-Type": file.type,
			"X-File-LastModified": Math.round(file['lastModified'] / 1000).toString()
		});
		options.headers = headers
		options.body = file;

		const response = await fetch(url, options);
		if(!response.ok) {
			throw await this.createErrorFromResponse(response);
		}
		return await response.json();

	}


	static markArrayDeleted(oldVal:any[], newVal:any[], matchBy = 'id') {
		const deleted = oldVal.filter((group) => {
			return newVal.findIndex((g) => {
				return g[matchBy] == group[matchBy];
			}) === -1;
		});

		deleted.forEach((g)=>{
			newVal.push({
				[matchBy]: g[matchBy],
				markDeleted: true
			})
		})

		return newVal;
	}

}